import { observer } from "mobx-react-lite";
import { Header, Icon, Segment } from "semantic-ui-react";
import React from "react";
import styles from "./Resources.module.css";

interface ResourceRowProps {  
  urlText: string;
  url: string;
  descriptionText?: string;
  taskHeaderText?: string;
  groupedHeaderText?: string;
}

const ResourceRow: React.FC<ResourceRowProps> = (props) => {
  const { url, urlText, descriptionText, taskHeaderText, groupedHeaderText } = props;

  
  const renderTaskTitle = () => {
    return (
      <>
        <Segment vertical >
            <Header as='h2' id={styles.resourceTaskTitle} >
                {taskHeaderText}
            </Header>
        </Segment>           
      </>
    )
  }  
  const renderGroupedTitle = () => {
    return (
      <>
        <Segment vertical >
            <Header as='h2' className={styles.resouceGroupedTitle} >
                {groupedHeaderText}
            </Header>
        </Segment>           
      </>
    )
  }

  return (
    <>
    {!!taskHeaderText && renderTaskTitle()}
    {!!groupedHeaderText && renderGroupedTitle()}
    <Segment vertical >
      <Header as='h2' >
        <Header.Content className={styles.resouceHeaderContent}> 
          <a href={url} target="_blank" rel="noreferrer">            
            <Icon name='linkify' size="small" className={styles.resourceLinkIcon} />
            {urlText}
          </a>
          <Header.Subheader className={styles.resourceInfoText} >
            {descriptionText}
          </Header.Subheader>
        </Header.Content>
      </Header>
    </Segment>    
    </>
  );
};

export default observer(ResourceRow);
